module.exports = __webpack_public_path__ + "static/media/parking4.d1ff7409.jpg";